/**
 * The page to load after "Sign in again" on the SignInFailed page.
 *
 * The requested page arrives as a query parameter, so it is only trusted when it resolves to this origin. The
 * check is left to the URL parser rather than a pattern, because browsers normalise the string first (for
 * example by stripping tab and newline characters), so `/\t/evil.example` would otherwise pass a check for a
 * single leading `/` and still navigate to another site.
 */
export function signInAgainTarget(page?: string): string {
    if (!page) {
        return '/';
    }
    try {
        const url = new URL(page, window.location.origin);
        return url.origin === window.location.origin ? url.pathname + url.search + url.hash : '/';
    } catch {
        return '/';
    }
}
